import { Checkbox, Select } from 'antd';

import CustomDialog from './CustomDialog';
import useTranslation from '../../customHooks/translate';

interface IProps {
  modalMode: string;
  open: boolean;
  handleClose: () => void;
  handleSave: () => void;
  activeTabKey: string;
  partnerData: any;
  handleInputChange: (key: string, value: any) => {};
  reports;
  partners;
  debitors;
  creditors;
}

const PermissionSubUserForm = ({
  modalMode,
  open,
  handleClose,
  handleSave,
  activeTabKey,
  partnerData,
  handleInputChange,
  reports,
  partners,
  debitors,
  creditors,
}: IProps) => {
  const translation = useTranslation();

  return (
    <CustomDialog
      open={open}
      handleClose={handleClose}
      title={
        modalMode === 'add'
          ? `${translation.subusers.addPerm}`
          : `${translation.subusers.editPerm}`
      }
      buttonTitle={translation.PaymentReceived.Save}
      onSubmit={handleSave}
    >
      <div className="flex flex-col gap-[20px]">
        <div className="flex flex-col gap-[12px]">
          <label className="text-[14px] font-semibold text-[#1D1D1D] md:text-[16px]">
            {activeTabKey === '3'
              ? `${translation.sideMenu.Reports}`
              : activeTabKey === '2'
              ? `${translation.profile.debitors}`
              : `${translation.profile.creditors}`}
          </label>
          <Select
            dropdownStyle={{ zIndex: 2000 }}
            value={
              activeTabKey === '3'
                ? partnerData.reportId
                : partnerData.partnerId
            }
            className="select-input"
            onChange={(value) => {
              const selectedOption =
                activeTabKey === '3'
                  ? reports?.find((report) => report.id === value)
                  : partners?.find((partner) => partner.id === value);

              if (selectedOption) {
                handleInputChange(
                  activeTabKey === '3' ? 'reportId' : 'partnerId',
                  selectedOption.id
                );
                handleInputChange(
                  'partnerName',
                  activeTabKey === '3'
                    ? selectedOption.reportName
                    : selectedOption.name
                );
              }
            }}
            disabled={modalMode === 'edit'}
            placeholder={
              activeTabKey === '3'
                ? `${translation.sideMenu.Reports}`
                : activeTabKey === '2'
                ? `${translation.profile.debitors}`
                : `${translation.profile.creditors}`
            }
          >
            {activeTabKey === '3'
              ? reports?.map((report) => (
                  <Select.Option key={report.id} value={report.id}>
                    {report.name}
                  </Select.Option>
                ))
              : activeTabKey === '2'
              ? debitors?.map((partner) => (
                  <Select.Option key={partner.id} value={partner.id}>
                    {partner.name}
                  </Select.Option>
                ))
              : creditors?.map((partner) => (
                  <Select.Option key={partner.id} value={partner.id}>
                    {partner.name}
                  </Select.Option>
                ))}
          </Select>
        </div>

        <div className="flex flex-col gap-[12px]">
          <label className="text-[14px] font-semibold text-[#1D1D1D] md:text-[16px]">
            {translation.subusers.Permissions}
          </label>
          <div className="flex justify-between">
            {activeTabKey === '3' ? (
              <Checkbox
                checked={partnerData.read}
                onChange={(e) => handleInputChange('read', e.target.checked)}
              >
                {translation.subusers.view}
              </Checkbox>
            ) : (
              <>
                <Checkbox
                  checked={partnerData.read}
                  onChange={(e) => handleInputChange('read', e.target.checked)}
                >
                  {translation.subusers.view}
                </Checkbox>

                <Checkbox
                  checked={partnerData.create}
                  onChange={(e) =>
                    handleInputChange('create', e.target.checked)
                  }
                >
                  {translation.subusers.create}
                </Checkbox>

                <Checkbox
                  checked={partnerData.update}
                  onChange={(e) =>
                    handleInputChange('update', e.target.checked)
                  }
                >
                  {translation.subusers.update}
                </Checkbox>

                <Checkbox
                  checked={partnerData.delete}
                  onChange={(e) =>
                    handleInputChange('delete', e.target.checked)
                  }
                >
                  {translation.subusers.delete}
                </Checkbox>
              </>
            )}
          </div>
        </div>
      </div>
    </CustomDialog>
  );
};

export default PermissionSubUserForm;
